import React, { useState } from "react";
import { Button, Container, Row, Col, Alert } from "reactstrap";
import { useHistory } from "react-router";
import cx from "classnames";

import CopyWidget from "../../../../../components/CopyWidget/CopyWidget";
import BackButton from "../../../../../components/BackButton";
import WeaveTopBar from "../../../../../components/WeaveTopBar/WeaveTopBar";
import DownloadProgress from "../../../../../components/DownloadProgress/DownloadProgress";
import Defaults from "../../../../../helpers/Defaults";
import SectionInputWidget from "../../../../../components/SectionInputWidget/SectionInputWidget";
import WeaveCheckbox from "../../../../../components/WeaveCheckbox/WeaveCheckbox";

import s from "../MarketRegisterPage.module.scss";
import PathHelper from "../../../PathHelper";

export default function MarketGenerateKey() {
	const history = useHistory();

	const [hasAgreed, setHasAgreed] = useState(false);
	const [nickname, setNickname] = useState("");

	// ------------------------------------- METHODS -------------------------------------
	const user = {
		name: "Johnny C.",
		publicKey: "acmeMFYwEAYHKoZIzj0CAQYFK4EEAA",
		avatar: "marketUserAvatar",
	};

	const onContinue = () => {
		const { name, publicKey, avatar } = user;

		let params = [];
		if (name) params.push(`name=${name}`);
		if (publicKey) params.push(`publicKey=${publicKey}`);
		if (avatar) params.push(`avatar=${avatar}`);

		history.push({
			pathname: PathHelper.getPath("market", ""),
			search: `?${params.join("&")}`,
		});
	};

	return (
		<div className={s.welcome}>
			<WeaveTopBar />

			<Container fluid className={s.welcomePage}>
				<BackButton />

				<Row className={s.titleContainer}>
					<Col lg="12" sm="12">
						<div className="d-flex align-items-center justify-content-center">
							<p className={s.title}>generating account keys</p>
						</div>
					</Col>
				</Row>

				{/* PUBLIC KEY */}
				<CopyWidget
					title="This is your account’s public key"
					className={s.copyInput}
					text={""}
				/>

				<Row className={s.warningSection}>
					<Col sm="12">
						<Alert color="primary">
							<p className={"text"}>
								You can access and copy your public key easily from anywhere in
								the application. When you share your public key with others,
								they can invite you to access data and/or deposit funds in your
								Weavechain wallet.
							</p>
						</Alert>
					</Col>
				</Row>

				{/* PRIVATE KEY */}
				<DownloadProgress
					fileName={Defaults.PRIVATE_KEY_EXPORT_ACC_FILE}
					keyData={""}
					onDownloadComplete={() => {}}
					title="New account private key downloading"
				/>

				<Row className={s.warningSection}>
					<Col sm="12">
						<Alert color="warning">
							<p className={"text"}>
								<span>Warning:&nbsp;</span>
								Your private key is not stored anywhere on our servers.
								<span>
									&nbsp;If you lose it, you will be unable to access your
									account.
								</span>
								&nbsp;Please store it in a secure location that you will
								remember.
							</p>
						</Alert>
					</Col>
				</Row>

				{/* Nickname */}
				<SectionInputWidget
					icon="user"
					value={nickname}
					title="Enter a nickname"
					placeholder="ex. Johnny Carson"
					subTitle="Enter a username to identify your public Key"
					onChange={setNickname}
				/>

				<Row className={cx(s.termsContainer, "row")}>
					<Col sm="12" className="d-flex justify-content-center">
						<WeaveCheckbox
							checked={hasAgreed}
							onChange={() => setHasAgreed(!hasAgreed)}
							label="I understand that I will not be able to recover my private
							key and should store it in a secure location."
						/>
					</Col>
				</Row>

				<Row className={cx(s.btnContainer, "row")}>
					<Col sm="12" className="d-flex justify-content-center">
						<Button
							color="primary"
							className="btn-default dark"
							disabled={!hasAgreed}
							onClick={onContinue}
						>
							Continue
						</Button>
					</Col>
				</Row>
			</Container>
		</div>
	);
}
